// Vendor libraries
import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "../../loaders/loading-symbol/loading-symbol.component";
import * as i4 from "../modal-base/components/modal-base.component";
import * as i5 from "../modal-base/components/simple-modal-footer.component";
import * as i6 from "../modal-base/components/simple-modal-header.component";
const _c0 = ["promptInput"];
const _c1 = a0 => ({ "is-invalid": a0 });
function PromptModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loaderMessage", ctx_r1.loaderMessage);
} }
function PromptModalComponent_ng_template_4_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.promptInstructionHTML, i0.ɵɵsanitizeHtml);
} }
function PromptModalComponent_ng_template_4_Conditional_3_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.promptInstructionText);
} }
function PromptModalComponent_ng_template_4_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PromptModalComponent_ng_template_4_Conditional_3_p_0_Template, 2, 1, "p", 15);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.promptInstructionText);
} }
function PromptModalComponent_ng_template_4_Case_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16, 1);
    i0.ɵɵlistener("keydown.enter", function PromptModalComponent_ng_template_4_Case_5_Template_input_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.handleEnterKey()); });
    i0.ɵɵtwoWayListener("ngModelChange", function PromptModalComponent_ng_template_4_Case_5_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.state.promptInput, $event) || (ctx_r1.state.promptInput = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function PromptModalComponent_ng_template_4_Case_5_Template_input_ngModelChange_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.inputChangeHandler()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r1.promptPlaceholder)("maxlength", ctx_r1.maxInputLength)("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx_r1.state.hasInvalidInput));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.promptInput);
} }
function PromptModalComponent_ng_template_4_Case_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 17, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function PromptModalComponent_ng_template_4_Case_6_Template_textarea_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.state.promptInput, $event) || (ctx_r1.state.promptInput = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function PromptModalComponent_ng_template_4_Case_6_Template_textarea_ngModelChange_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.inputChangeHandler()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rows", ctx_r1.rows)("placeholder", ctx_r1.promptPlaceholder)("maxlength", ctx_r1.maxInputLength)("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx_r1.state.hasInvalidInput));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.promptInput);
} }
function PromptModalComponent_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.state.error);
} }
function PromptModalComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵconditionalCreate(2, PromptModalComponent_ng_template_4_Conditional_2_Template, 1, 1, "div", 10)(3, PromptModalComponent_ng_template_4_Conditional_3_Template, 1, 1, "p");
    i0.ɵɵelement(4, "div", 11);
    i0.ɵɵconditionalCreate(5, PromptModalComponent_ng_template_4_Case_5_Template, 2, 6, "input", 12)(6, PromptModalComponent_ng_template_4_Case_6_Template, 2, 7, "textarea", 13);
    i0.ɵɵtemplate(7, PromptModalComponent_ng_template_4_div_7_Template, 1, 1, "div", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.promptInstructionHTML !== null ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.promptText);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_4_0 = ctx_r1.inputType) === "text" ? 5 : tmp_4_0 === "textarea" ? 6 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !!ctx_r1.state.error);
} }
/**
 *
 * Prompt Modal Component
 *
 * Input Properties:
 *
 *  promptButtonText: Text used for the button
 *  promptHeader: Text used for the header of the modal.
 *  promptInputText: Initial text in the input field.
 *  promptInstructionText: Instruction text to be displayed in the modal.
 *  promptInstructionHTML: Instruction HTML to be displayed in the modal. When both 'promptInstructionText' and
 *                        'promptInstructionHTML' are provided, 'promptInstructionHTML' takes precedence.
 *  promptPlaceholder: Placeholder text for the input field.
 *  promptText: Text used in the modal content section.
 *  maxInputLength: Maximum number of characters that the input field allows.
 *  loaderMessage: Message to show with the loading symbol in the modal. Useful when the promptHandler
 *                 triggers a request that takes a couple of seconds or more.
 *  clearInputOnClose: Whether the input text should be cleared when the modal is closed.
 *  modalTestId: Used to set the data-test-id attributes of the modal's and its child components
 *                    (footer, confirm button, etc). Make sure this is as unique as possible to avoid test-breaking
 *                    collisions between two elements having the same `data-test-id`
 *  modalClasses: Additional classes to be added to the modal dialog container.
 *  rows: Number of rows for the textarea input.
 *  inputType: Type of input, either 'text' or 'textarea'.
 *
 * Output Properties:
 *
 *  closeModalHandler: Emits an event when the prompt modal is closed
 *  promptHandler: EventEmitter that emits when the user completes or cancels
 *
 */
export class PromptModalComponent {
    constructor() {
        this.maxInputLength = null;
        this.loaderMessage = '';
        this.clearInputOnClose = true;
        this.modalClasses = 'modal-sm';
        this.rows = 5;
        this.inputType = 'text';
        this.closeModalHandler = new EventEmitter();
        this.promptHandler = new EventEmitter();
        this.INITIAL_STATE = {
            modalOpen: false,
            canSubmit: false,
            promptInput: '',
            hasInvalidInput: false,
            error: '',
        };
        this.state = { ...this.INITIAL_STATE };
    }
    ngOnChanges(changes) {
        if (changes?.promptInputText?.currentValue) {
            this.state = { ...this.state, promptInput: changes.promptInputText.currentValue, canSubmit: true };
        }
    }
    handleEnterKey() {
        if (this.state.canSubmit) {
            this.submit();
        }
    }
    submit() {
        this.promptHandler.emit(this.state.promptInput);
    }
    inputChangeHandler() {
        const input = this.state.promptInput;
        this.state = {
            ...this.state,
            error: '',
            canSubmit: input !== undefined && input !== null && input !== '',
            hasInvalidInput: input === undefined || input === null,
        };
    }
    openModal() {
        this.state.modalOpen = true;
        // Wait for the modal to be rendered before attempting to find and focus the element.
        setTimeout(() => {
            this.promptInput.nativeElement.focus();
        });
    }
    closeModal() {
        const promptInput = this.clearInputOnClose ? '' : this.promptInputText ?? '';
        this.state = {
            ...this.INITIAL_STATE,
            promptInput,
            canSubmit: !!promptInput,
        };
        this.closeModalHandler.emit();
    }
    setErrorMessage(errorMessage) {
        this.state = {
            ...this.state,
            canSubmit: false,
            hasInvalidInput: true,
            error: errorMessage || 'An unknown error occurred. Please try again or contact support.',
        };
    }
}
PromptModalComponent.ɵfac = function PromptModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PromptModalComponent)(); };
PromptModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PromptModalComponent, selectors: [["ycn-prompt-modal"]], viewQuery: function PromptModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.promptInput = _t.first);
    } }, inputs: { promptButtonText: "promptButtonText", promptHeader: "promptHeader", promptInputText: "promptInputText", promptInstructionText: "promptInstructionText", promptInstructionHTML: "promptInstructionHTML", promptPlaceholder: "promptPlaceholder", promptText: "promptText", maxInputLength: "maxInputLength", loaderMessage: "loaderMessage", clearInputOnClose: "clearInputOnClose", modalTestId: "modalTestId", modalClasses: "modalClasses", rows: "rows", inputType: "inputType" }, outputs: { closeModalHandler: "closeModalHandler", promptHandler: "promptHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 10, consts: [["showInput", ""], ["promptInput", ""], [3, "closeModalHandler", "extraModalClasses", "focusElementId", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf", "ngIfElse"], [3, "cancelHandler", "submitHandler", "disableSubmission", "submitButtonText", "modalTestId"], [3, "loaderMessage"], [1, "modal-section"], [1, "form-row"], [3, "innerHTML"], [1, "form-label", 3, "textContent"], ["type", "text", "id", "promptFocus", "data-test", "prompt-input", "data-test-id", "prompt-modal-input", 1, "form-control", 3, "placeholder", "maxlength", "ngClass", "ngModel"], ["data-test", "prompt-input", "data-test-id", "prompt-modal-input", 1, "form-control", 2, "resize", "none", 3, "rows", "placeholder", "maxlength", "ngClass", "ngModel"], ["class", "feedback feedback-invalid", 3, "textContent", 4, "ngIf"], [4, "ngIf"], ["type", "text", "id", "promptFocus", "data-test", "prompt-input", "data-test-id", "prompt-modal-input", 1, "form-control", 3, "keydown.enter", "ngModelChange", "placeholder", "maxlength", "ngClass", "ngModel"], ["data-test", "prompt-input", "data-test-id", "prompt-modal-input", 1, "form-control", 2, "resize", "none", 3, "ngModelChange", "rows", "placeholder", "maxlength", "ngClass", "ngModel"], [1, "feedback", "feedback-invalid", 3, "textContent"]], template: function PromptModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function PromptModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function PromptModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, PromptModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 5)(4, PromptModalComponent_ng_template_4_Template, 8, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ycn-simple-modal-footer", 6);
        i0.ɵɵlistener("cancelHandler", function PromptModalComponent_Template_ycn_simple_modal_footer_cancelHandler_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("submitHandler", function PromptModalComponent_Template_ycn_simple_modal_footer_submitHandler_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const showInput_r5 = i0.ɵɵreference(5);
        i0.ɵɵproperty("extraModalClasses", ctx.modalClasses)("focusElementId", "promptFocus")("open", ctx.state.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.promptHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loaderMessage)("ngIfElse", showInput_r5);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disableSubmission", !ctx.state.canSubmit)("submitButtonText", ctx.promptButtonText)("modalTestId", ctx.modalTestId);
        i0.ɵɵattribute("data-test-id", ctx.modalTestId ? ctx.modalTestId + "-footer" : ctx.promptHeader + "-footer");
    } }, dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.MaxLengthValidator, i2.NgModel, i3.LoadingSymbolComponent, i4.ModalBaseComponent, i5.SimpleModalFooterComponent, i6.SimpleModalHeaderComponent], encapsulation: 2 });
